import React from 'react';
import {Container, Row } from 'react-bootstrap';


import productList from './../../product-list.json';
import ProductCard from './ProductCard'

const Product = (props)=>{
	
	const productItems = [];	
	for (const key in productList){
		const product = productList[key]
		productItems.push(
			<ProductCard
				key={product.sku}
				img_l={require(`./${product.sku}@l.jpg`)}
				img_m={require(`./${product.sku}@m.jpg`)}
				img_s={require(`./${product.sku}@s.jpg`)}
				img_xs={require(`./${product.sku}@xs.jpg`)}
				title={product.title}
				price={product.price}
				description={product.description}
				link={product.link}
				colxs={10}
				colsm={6}
				colmd={4}
				collg={3}
			/>
		);
	}

	return(
		<Container fluid className="product_list-wrapper" id={props.id}>
			<Row>
				<h2 className="row-title">{props.title}</h2>
			</Row>
			<Row>
				{productItems}
			</Row>
		</Container>
	)
}

export default Product;